export const GET_MACHINE_LIST_REQUEST = "GET_MACHINE_LIST_REQUEST";
export const GET_MACHINE_LIST_SUCCESS = "GET_MACHINE_LIST_SUCCESS";
export const GET_MACHINE_LIST_FAILED = "GET_MACHINE_LIST_FAILED";
